// extracted by mini-css-extract-plugin
export default {"wrap":"ReferralView_wrap__0WVVk","tools":"ReferralView_tools__PgVth","item":"ReferralView_item__1POWj","label":"ReferralView_label__DGce+","value":"ReferralView_value__YHbVN"};